module.exports = __webpack_public_path__ + "static/media/masala-veggie-burger-mb-en.22d0669f.jpg";